import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { ContaBancariaAtualizar, ContaBancariaCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import ContaBancariaController from '../../../../controllers/ContaBancariaController';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  ctb_id: number;
  // Código FEBRABAN: '001' Banco do Brasil, '756' Sicoob. Fonte única da instituição.
  ctb_codigoBanco?: string;
  ctb_descricao: string;
  ctb_conta: string;
  ctb_contaDigito: string;
  // 'S' na única conta que emite boletos hoje, 'N' nas demais.
  ctb_contaEmissaoBoleto?: string;
  BtnMenu?: JSX.Element;
}

export default function ContaBancaria() {
  const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align:'center' },
    { id: 'CodigoBanco', label: 'Cód. Banco', minWidth: 0, maxWidth: 0, align:'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'Conta', label: 'Conta', minWidth: 0 },
    { id: 'DigitoConta', label: 'Dígito', minWidth: 0 },
    { id: 'EmiteBoleto', label: 'Emite Boleto', minWidth: 0, maxWidth: 0, align: 'center' },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const fields = [
    { name: 'ContaBancariaId', type: 'text', label: 'Código' },
    { name: 'CodigoBanco', type: 'text', label: 'Cód. Banco' },
    { name: 'Descricao', type: 'text', label: 'Banco' },
    { name: 'Conta', type: 'text', label: 'Conta' },
    { name: 'DigitoConta', type: 'text', label: 'Dígito' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ];
  
  const initialValues = {
    ContaBancariaId: null,
    CodigoBanco: '',
    Descricao: '',
    Conta: '',
    DigitoConta: '',
  };

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(ContaBancariaCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(ContaBancariaAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(ContaBancariaAtualizar.replace(':id', item.ctb_id!.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    console.log("values:", values)
    const Response = await ContaBancariaController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({                     
          Id: item.ctb_id,
          CodigoBanco: item.ctb_codigoBanco,
          Descricao: item.ctb_descricao,
          Conta: item.ctb_conta,
          DigitoConta: item.ctb_contaDigito,
          // Só uma conta fica com 'S': é por ela que todo boleto novo é emitido.
          EmiteBoleto: item.ctb_contaEmissaoBoleto === 'S' ? 'Sim' : 'Não',
           BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () => handleDeleteItem(item.ctb_id),
                  menu: 'Excluir', confirmar: `Excluir a conta bancária "${item.ctb_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const handleDeleteItem = async (ctb_id: number) => {
    const request: any = { UsuId: userId, ContaBancariaId: ctb_id };
    const response = await ContaBancariaController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Condição de Pagamento excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir a condição de pagamento!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box>
      <HeaderComponent text={'CONTAS BANCÁRIAS'}
        ButtonRight={
          <Button
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
